export default __webpack_public_path__ + "static/media/logo-landing-page.dc95ec80.png";